/**
 * [Cookie Manager]
 */
import store from "@/store/index";
import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import { iosHeaders, baseUrl } from "@/api/http/ins/insConst";
import Utf8 from "crypto-js/enc-utf8";
import Base64 from "crypto-js/enc-base64";
import { formatCookie } from "@/api/http/utils/apiHelpers";

export class CookieManager {
  public getCrosTokenByUserId(userId: number | string) {
    const cookie = store.getters[types.GETTER_COOKIE_BY_USER_ID](userId);
    return cookie.csrftoken ? cookie.csrftoken : "";
  }
}
const cookieManager = new CookieManager();

let actionCloseCookie: any = null;

export const cacheLoginCookie = async () => {
  const result: any = await Http.GetCookie(baseUrl);
  const words = Base64.parse(result);
  const textString = Utf8.stringify(words);
  const lastWord = JSON.parse(textString);

  actionCloseCookie = formatCookie(lastWord);
  console.log("cacheLoginCookie:", actionCloseCookie);
};

export const clearActionCloseCookie = () => {
  actionCloseCookie = null;
};

export const getActionCloseCookie = () => {
  return actionCloseCookie;
};

export default cookieManager;
